import { configureStore, combineReducers } from '@reduxjs/toolkit';
import notificationsReducer from '@redux/features/notificationsSlice';
import paymentMethodsReducer from '@redux/features/paymentMethodsSlice';
import subscriptionsReducer from '@redux/features/subscriptionsSlice';
import authReducer, { logoutUser } from '@redux/features/authSlice';
import transactionsReducer from '@redux/features/transactionsSlice';
import cashboxesReducer from '@redux/features/cashboxesSlice';
import locationsReducer from '@redux/features/locationsSlice';
import paymentsReducer from '@redux/features/paymentsSlice';
import sessionsReducer from '@redux/features/sessionsSlice';
import coachesReducer from '@redux/features/coachesSlice';
import clientsReducer from '@redux/features/clientsSlice';
import entriesReducer from '@redux/features/entriesSlice';
import groupsReducer from '@redux/features/groupsSlice';
import usersReducer from '@redux/features/usersSlice';

const appReducer = combineReducers({
  paymentMethods: paymentMethodsReducer,
  subscriptions: subscriptionsReducer,
  notifications: notificationsReducer,
  transactions: transactionsReducer,
  cashboxes: cashboxesReducer,
  locations: locationsReducer,
  payments: paymentsReducer,
  sessions: sessionsReducer,
  clients: clientsReducer,
  entries: entriesReducer,
  coaches: coachesReducer,
  groups: groupsReducer,
  users: usersReducer,
  auth: authReducer,
});

const rootReducer = (state, action) => {
  if (action.type === logoutUser.type) {
    state = undefined;
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
});
